import React from 'react'
import { useAuth } from '../context/AuthContext.jsx'

export default function ProfilePage() {
  const { user } = useAuth()
  if (!user) {
    return (
      <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <div>
          <h2>You need to sign in to view your profile</h2>
        </div>
      </div>
    )
  }

  const memberSince = user.createdAt ? new Date(user.createdAt).toLocaleDateString() : '—'
  const role = user.role || 'user'

  return (
    <div style={{ maxWidth: 720, margin: '24px auto', padding: '0 16px' }}>
      <h1 style={{ marginBottom: 16 }}>Profile</h1>
      <div style={{
        border: '1px solid var(--elev)', borderRadius: 12, padding: 16,
        background: 'var(--bg)'
      }}>
        <div style={{ display: 'grid', rowGap: 12 }}>
          <div><strong>Username:</strong> {user.username}</div>
          <div><strong>Email:</strong> {user.email}</div>
          <div><strong>Role:</strong> {role}</div>
          <div><strong>Member since:</strong> {memberSince}</div>
        </div>
      </div>
    </div>
  )
}
